module.exports = __webpack_public_path__ + "img/logo.b03ee593.png";